import Vue from 'vue'
import ElementUI from 'element-ui'
import router from './index'
import qs from 'qs'
import {examineApi ,messagesNewApi, getUserId, messagesCbApi, postTest} from '@/api'
import store from "../store";
import { MessageBox } from 'element-ui';
Vue.use(ElementUI)
let routerControle = function() {

  router.beforeEach((to, from, next) => {
      if ((from.path == '/service' || from.path == '/serviceIng')&& to.path != '/serviceIng') { // 从配置服务或授权中过来，清除掉调用 授权信息  的定时器
        clearInterval(Vue.time)
    }
    if (to.fullPath != '/login' && to.fullPath != '/register' && to.fullPath != '/forgetPassword' && to.fullPath != '/editPassword') {
      // if (to.fullPath == '/') {
      //   window.location.href = '/homePage'
      //   return
      // }
      if (from.path == '/skillInfo' || from.path == '/test') {//跳转时关闭技能接口
        async function test() {
          let data = store.state.obj
          if (!data.query) return
            data.query = '关闭'
            let res = await postTest(data)
          store.dispatch('changedevId',{});
       }
        test()

      }
      if (to.matched[0].path == '/tutor' || to.fullPath == '/hardhome' || to.fullPath == '/homePage') {
        next()
      } else {
        if (!store.state.switchRoute && (from.path == '/createIntention' || from.path == '/editIntention' || from.path == '/createDictionaries' || from.path == '/editDictionaries'|| from.path == '/updateSkill' || from.path == '/proInfo' || from.path == '/propelling' || from.path == '/service' || from.path == '/release')) {
          if ((from.path == '/createIntention' && to.path == '/editIntention') || (from.path == '/propelling' && to.path == '/PropellingSuc') || (from.path == '/release' && to.path == '/edition') || (from.path == '/createDictionaries' && to.path == '/dictionariesList')) {
            let token = 0
            let cookieName = 'token'
            if (document.location.host == 'opentw.ainirobot.com') {
                cookieName = 'token_tw'
            }
            let arr, reg = new RegExp("(^| )" + cookieName + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg)) {
              token = arr[2]
            }
            else {
              token = null;
            }
            token ? next() : window.location.href = '/login'
          } else {
            ElementUI.MessageBox.confirm('正在编辑中，跳转将丢失已修改的内容, 您确定要跳转吗?', '温馨提示', {
              cancelButtonClass: 'cancelMessage',
              showCancelButton: true}).then(() => {
              let token = 0
                let cookieName = 'token'
                if (document.location.host == 'opentw.ainirobot.com') {
                    cookieName = 'token_tw'
                }
                let arr, reg = new RegExp("(^| )" + cookieName + "=([^;]*)(;|$)");
              if (arr = document.cookie.match(reg)) {
                token = arr[2]
              }
              else {
                token = null;
              }
              token ? next() : window.location.href = '/login'
            }).catch(() => {

            });
          }
        } else {
          let token = 0
            let cookieName = 'token'
            if (document.location.host == 'opentw.ainirobot.com') {
                cookieName = 'token_tw'
            }
            let arr, reg = new RegExp("(^| )" + cookieName + "=([^;]*)(;|$)");
          if (arr = document.cookie.match(reg)) {
            token = arr[2]
          }
          else {
            token = null;
          }
          token ? next() : window.location.href = '/login'
        }
      }
    }else {
      next()
    }
    document.title ='猎户语音OS-开放平台';
    async function examine() {
//        -1 冻结，0 已注册，1 审核不通过，2 审核通过，3审核中
      let res = await examineApi()
      if (!res) return
      if (res.data.code == 200) {
        store.dispatch("changeIsDeveloper", res.data.data.status);
      }
    }
    examine();//获取用户审核状态
    let user_id = '';
    async function getUserStart() {//获取用户id skillId
      let res = await getUserId();
      if (!res) return
      user_id = res.data.data.id;
      if(user_id != ''){
        getMessageNum(user_id);
      }
    }
    async function getMessageNum(id) {
      let res = await messagesNewApi(qs.stringify({user_id: id}));
      if (res.data.code == 200) {
        let msg_num = Number(res.data.data.new_message_num);
        store.dispatch('changeMessageNum',msg_num);
      }
    }
    getUserStart();//同步消息数量
  });
  router.afterEach((to, from, next)=>{

      //大陆添加GA监控(线上环境)
      gtag('config', 'UA-121642873-7', {'page_path': to.path});
      
      //台湾添加GA监控(线上环境)
      gtag('config', 'UA-121642873-22', {'page_path': to.path});
      
      //本地GA监控
      // gtag('config', 'UA-121642873-8', {'page_path': to.path});

    store.dispatch('changeR',true);
    if(to.matched[0].path != '/hardhome' && to.matched[0].path != '/homePage'){
      store.dispatch('changeF');
    }
  })
}
export default routerControle;



// WEBPACK FOOTER //
// ./src/router/routerControle.js